"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ant_design_vue_1 = require("ant-design-vue");
const vue_1 = require("vue");
const plugin_1 = require("@/plugin");
exports.default = (0, vue_1.defineComponent)({
    name: 'FloatAutoModal',
    components: {
        Modal: ant_design_vue_1.Modal
    },
    data() {
        const data = {
            visible: false,
            title: undefined,
            option: {
                props: null,
                auto: null
            }
        };
        return data;
    },
    props: {
        optionProps: {
            type: Object,
            required: false,
            default: () => {
                return null;
            }
        },
        menuList: {
            type: Object,
            required: false
        },
        heightLayout: {
            type: String,
            required: false
        },
        onEvent: {
            type: Object,
            required: true
        },
        top: {
            type: Number,
            required: false,
            default: 50
        },
        bottom: {
            type: Number,
            required: false,
            default: 50
        },
        header: {
            type: Number,
            required: false,
            default: 55
        },
        menu: {
            type: Number,
            required: false,
            default: 53
        },
        padding: {
            type: Object,
            required: false,
            default: () => {
                return {
                    width: 48,
                    height: 48
                };
            }
        }
    },
    computed: {
        currentContentStyle() {
            const style = {};
            const height = this.height + 'px';
            if (this.heightLayout === 'fixed') {
                style.height = height;
            }
            else {
                style.maxHeight = height;
            }
            return style;
        },
        currentOptionProps() {
            const optionProps = {
                style: {}
            };
            if (this.optionProps) {
                for (const prop in this.optionProps) {
                    optionProps[prop] = this.optionProps[prop];
                }
            }
            if (this.option.props) {
                for (const prop in this.option.props) {
                    optionProps[prop] = this.option.props[prop];
                }
            }
            if (this.title !== undefined) {
                optionProps.title = this.title;
            }
            optionProps.footer = null;
            optionProps.style.top = this.top + 'px';
            return optionProps;
        },
        height() {
            const mainHeight = plugin_1.reactiveLayout.data.body.height;
            let height = mainHeight - this.top - this.bottom - this.header - this.padding.height;
            if (this.menuList) {
                // 存在menuList则进行计算，可能不存在按钮，但是可以通过布局模拟展示按钮
                height = height - this.menu;
            }
            return height;
        },
        width() {
            let width = 520;
            if (this.currentOptionProps.width) {
                width = this.currentOptionProps.width;
            }
            return width - this.padding.width;
        }
    },
    methods: {
        initOption(option) {
            this.resetOption();
            if (option) {
                if (option.props) {
                    this.option.props = option.props;
                }
                if (option.auto) {
                    this.option.auto = option.auto;
                }
            }
        },
        resetOption() {
            this.option.props = null;
            this.option.auto = null;
        },
        show(title, option) {
            this.$show();
            this.title = title;
            this.initOption(option);
            if (this.onEvent) {
                this.onEvent('show');
            }
        },
        $show() {
            this.visible = true;
        },
        $hide() {
            this.visible = false;
        },
        close() {
            this.$hide();
            this.resetOption();
        },
        onHide() {
            this.onEvent('hide');
        },
        onCancel() {
            this.onEvent('cancel');
        },
        onOkAndHide() {
            this.onEvent('okAndHide');
        },
        onOk() {
            this.onEvent('ok');
        }
    }
});
